<template>
  <div
    :class="`card card-reward ${shaking ? 'animate_shake' : ''}`"
    @contextmenu="rewardFinal ? $emit('edit', kid) : null"
    @click="redeem()"
    v-if="reward"
    :updater="reward"
    :style="`background-image: url(${reward.get('image') || '/images/reward.jpeg'});`"
  >
    <div class="card-header">
      <center>
        <h3>{{ rewardName }}</h3>
      </center>
    </div>
    <div class="card-footer pb-inner">
      <span class="progressInfo">{{ points }}/{{ rewardValue }} points</span>
      <progress
        class="progress-bar"
        v-if="points < rewardValue"
        :value="points"
        :max="rewardValue"
      ></progress>
      <p
        class="btn rewardItem"
        @click="$emit('redeem')"
        v-else-if="!$route.path.includes('kids')"
        style="z-index: 9001"
        role="button"
      >
        Redeem
      </p>
      <div class="btn" style="z-index: 9001" role="button" aria-disabled="true" v-else>
        {{ $t("pages.kids.goodJob") }}
      </div>
    </div>
    <div class="overlay"></div>
  </div>
  <div v-else class="card">
    <div>
      <center>
        <h3>{{ $t("reward.title") }}</h3>
        <p>
          {{ $t("reward.subtitle") }}
          <br />
          {{ $tc("reward.currentPoints", points, { count: points }) }}
        </p>
      </center>
    </div>
    <div class="pb-inner hide-on-watch">
      <button
        class="btn btn-wide"
        v-if="mode !== 'kids'"
        @click="$router.push('/rewards')"
      >
        {{ $t("reward.addReward") }}
      </button>
    </div>
    <div class="overlay"></div>
  </div>
</template>
<script>
export default {
  props: ["kid", "mode", "reward"],
  data() {
    return {
      isCustom: false,
      rewardFinal: null,
      shaking: false,
    };
  },
  mounted() {
    if (!this.$props.reward) return;
    this.$props.reward.fetch().then((x) => {
      this.$data.rewardFinal = x;
    });
  },
  watch: {
    rewardFinal: function () {
      if (!this.$props.reward) return;
      this.$props.reward.fetch().then((x) => {
        this.$data.rewardFinal = x;
      });
    },
  },
  computed: {
    /**
     * The points of the child this card belongs to.
     *
     * The card is rendered before the child is loaded on a child device, so
     * the points are read through a value that is always a number.
     */
    points() {
      return this.$props.kid ? Number(this.$props.kid.get("points")) || 0 : 0;
    },
    rewardValue() {
      return this.$props.kid
        ? Number(this.$props.kid.get("rewardValue")) || 0
        : 0;
    },
    rewardName() {
      if (this.$data.rewardFinal) return this.$data.rewardFinal.get("name");
      return this.$props.reward ? this.$props.reward.get("name") : "";
    },
    percentageComplete() {
      if (!this.rewardValue) return 0;
      return this.points / this.rewardValue;
    },
  },
  methods: {
    async redeem() {
      // The card belongs to one child. The prop says which one, so the
      // reward is not taken from whichever child happens to be selected.
      const child =
        this.$props.kid ||
        this.$root.$data.kids[this.$root.$data.selectedChild];
      if (!child) return;
      const cost = Number(child.get("rewardValue")) || 0;
      const points = Number(child.get("points")) || 0;
      if (points - cost < 0) {
        this.$data.shaking = true;
        setTimeout(() => (this.$data.shaking = false), 1500);
        return;
      }
      const x = await ModernModals.prompt(
        `Would you like to redeem this reward for ${child.get("name")}?`
      );
      if (x) {
        // Take the points off with an increment, so a chore that was finished
        // on another device at the same time is not overwritten with a stale
        // total.
        child.increment("points", -cost);
        const customReward = child.get("customReward");
        if (customReward) {
          await customReward.destroy();
        }
        child.set("customReward", null);
        await child.save();
        await VueInstance.initLoadChores();
        VueInstance.$children[0].$children.forEach((x) => x.$forceUpdate());
      }
    },
    openAddReward() {
      AddRewardModal.open();
    },
    getProgess(kid, isPositive) {
      const value = Number(kid && kid.get("rewardValue")) || 0;
      const points = Number(kid && kid.get("points")) || 0;
      const pointsAsPercentPos = value ? (points / value) * 100 : 0;
      const pointsAsPercentNeg = 100 - pointsAsPercentPos;
      return isPositive ? pointsAsPercentPos : pointsAsPercentNeg;
    },
  },
};
</script>
